import { spacing } from '../../styles/jss/variables';
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()((theme, classes) => ({
    collectionInput: {
        position: 'relative',
        marginBottom: spacing.large,
        [theme.breakpoints.up('md')]: {
            marginBottom: spacing.xl,
        },
    },
    collectionTextarea: {
        '& .MuiInputBase-multiline': {
            alignItems: 'flex-start',
            minHeight: '100px',
            paddingRight: spacing.xxxl,
        },
    },
    collectionCharacterCount: Object.assign(Object.assign(Object.assign({ position: 'absolute', marginLeft: spacing.small }, theme.typography.xxs_regular), theme.typographySpacing.none), { top: '95px', right: '11px', [theme.breakpoints.up('md')]: {
            right: '9px',
        } }),
    title: Object.assign(Object.assign({}, theme.typography.xxs_bold), theme.typographySpacing.xxs_bold_sm),
    text: Object.assign(Object.assign({}, theme.typography.xxs_regular), theme.typographySpacing.xxs_regular_sm),
}));
export default useStyles;
